import { render, staticRenderFns } from "./report_topic.vue?vue&type=template&id=7288d1a0&scoped=true&"
import script from "./report_topic.vue?vue&type=script&lang=js&"
export * from "./report_topic.vue?vue&type=script&lang=js&"
import style0 from "./report_topic.vue?vue&type=style&index=0&id=7288d1a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7288d1a0",
  null
  
)

export default component.exports